import React, {useEffect} from 'react';
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import {PICTURES_PATH} from "../utils/consts";
import {useDispatch, useSelector} from "react-redux";
import {fetchGallery} from "../actions/gallery";

const Gallery = () => {
    const dispatch = useDispatch();
    const images = useSelector(state => state.gallery.images) || [];
    useEffect(() => {
        dispatch(fetchGallery());
    }, []);
    return (
        <div className="gallery-wrapper">
        <LightGallery speed={500} plugins={[lgZoom]} className="gallery-container">
            {images.map((image, index) => (
                <a href={`${PICTURES_PATH}gallery/${image.src}`} key={index} className="gallery-item">
                    <img src={`${PICTURES_PATH}gallery/${image.src}`} alt={image.title} className="gallery-image" />
                </a>
            ))}
        </LightGallery>
        </div>
    );
};

export default Gallery;